import { qualityMessage } from "../../utils/directorFormat";

const PROVENANCE_KEYS = new Set([
  "qualityFlags",
  "sourceIssueCodes",
  "quality_flags",
  "source_issue_codes",
]);

const asFlags = (value) => (
  (Array.isArray(value) ? value : [value])
    .filter((flag) => typeof flag === "string" && flag)
);

const collectSourceFlags = (sources = []) => {
  const collected = [];
  const visited = new WeakSet();
  const visit = (value) => {
    if (typeof value === "string") return;
    if (!value || typeof value !== "object" || visited.has(value)) return;
    visited.add(value);
    if (Array.isArray(value)) {
      value.forEach(visit);
      return;
    }
    if (
      Object.prototype.hasOwnProperty.call(value, "data")
      && Object.prototype.hasOwnProperty.call(value, "dataSignature")
      && Object.prototype.hasOwnProperty.call(value, "requestSignature")
    ) {
      if (
        typeof value.dataSignature !== "string"
        || value.dataSignature !== value.requestSignature
      ) return;
      visit(value.data);
      return;
    }
    Object.entries(value).forEach(([key, item]) => {
      if (PROVENANCE_KEYS.has(key)) {
        collected.push(...asFlags(item));
      } else {
        visit(item);
      }
    });
  };
  (Array.isArray(sources) ? sources : [sources]).forEach(visit);
  return collected;
};

const QualityBanner = ({
  flags = [],
  sourceIssueCodes = [],
  sources = [],
  status = "available",
}) => {
  const uniqueFlags = [...new Set([
    ...asFlags(flags),
    ...asFlags(sourceIssueCodes),
    ...collectSourceFlags(sources),
  ])].sort();
  const demo = uniqueFlags.includes("demo_mock_data");
  const qualityFlags = uniqueFlags.filter((flag) => flag !== "demo_mock_data");
  if (status === "available" && uniqueFlags.length === 0) return null;
  return <aside
    className={`director-quality${demo ? " director-quality--demo" : ""}`}
    aria-label={demo ? "Dados demonstrativos simulados" : "Qualidade dos dados"}
    role="status"
  >
    <strong>{demo
      ? "Dados demonstrativos simulados — não representam operação financeira real."
      : "Atenção à qualidade da leitura"}</strong>
    {qualityFlags.length > 0
      ? <ul>{qualityFlags.map((flag) => <li key={flag}>{qualityMessage(flag)}</li>)}</ul>
      : (!demo ? <p>A leitura possui restrições de qualidade.</p> : null)}
  </aside>;
};

export default QualityBanner;
